import { render, staticRenderFns } from "./DialogWrapper.vue?vue&type=template&id=af73e89a&scoped=true&"
import script from "./DialogWrapper.vue?vue&type=script&lang=ts&"
export * from "./DialogWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./DialogWrapper.vue?vue&type=style&index=0&id=af73e89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af73e89a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
